const Accordion = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.slideToggle.bind(this));
  }

  slideToggle(e: MouseEvent) {
    const id = (e.target?.closest(".ac-trigger") as HTMLElement)?.dataset.slidetoggle;

    if (!id) return;
    const el: HTMLElement | null = this.querySelector(id);
    const isCollapsed = el?.clientHeight === 0;
    if (!el) return;

    const maxH = parseInt(getComputedStyle(el)?.maxHeight?.replace("px", ""));
    const toHeight = !isNaN(maxH) && maxH < el.scrollHeight ? maxH : el.scrollHeight;

    el.style.height = (isCollapsed ? toHeight : 0) + "px";
    isCollapsed ? el.closest(".ac")?.classList.add("is-active") : el.closest(".ac")?.classList.remove("is-active");
  }
};

customElements.define("ui-accordion", Accordion);
